export default __webpack_public_path__ + "static/media/empresas.f6596585.png";